import { TICKER_SYMBOLS } from "../lib/constants";

function TickerRow() {
    return (
        <>
            {TICKER_SYMBOLS.map((t, i) => (
                <span
                    key={i}
                    data-testid={`ticker-item-${t.symbol.replace(/[^a-zA-Z0-9]/g, "")}`}
                    className="inline-flex items-baseline gap-2.5 px-5 font-mono text-[11px] uppercase tracking-wider"
                >
                    <span className="text-canvas/60">{t.symbol}</span>
                    <span className="text-canvas tabular-nums">{t.value}</span>
                    <span className={t.up ? "text-[#4ADE80] tabular-nums" : "text-[#FF7A72] tabular-nums"}>
                        {t.change}
                    </span>
                </span>
            ))}
        </>
    );
}

export function StockTicker() {
    return (
        <div
            className="relative h-8 flex items-center overflow-hidden bg-foreground"
            data-testid="stock-ticker"
        >
            <span className="hidden sm:inline-flex items-center h-full px-4 shrink-0 bg-accent text-accent-foreground eyebrow">
                Markets
            </span>
            <div className="relative flex-1 overflow-hidden">
                <div className="ticker-track">
                    <TickerRow />
                    <TickerRow />
                </div>
            </div>
        </div>
    );
}
